import React from "react";
import hermesIcon from "../../../public/hermes-icon.png";

interface LayoutProps {
  currentPage: string;
  onNavigate: (page: string) => void;
  children: React.ReactNode;
  email?: string | null;
  onLogout?: () => void;
}

const NAV_ITEMS = [
  { id: "dashboard", label: "Dashboard" },
  { id: "sow-upload", label: "SOW Upload" },
  { id: "notes", label: "Notes" },
  { id: "transcripts", label: "Transcripts" },
  { id: "task-groups", label: "Task Groups" },
  { id: "due-date-mover", label: "Due Date Mover" },
  { id: "call-notes", label: "Agenda Generator" },
  { id: "scoping-emails", label: "Scoping Emails" },
  { id: "qa", label: "QA Automation" },
  { id: "settings", label: "Settings" },
];

export function Layout({ currentPage, onNavigate, children, email, onLogout }: LayoutProps) {
  return (
    <div className="app-layout">
      <nav className="sidebar">
        <div className="sidebar-logo">
          <img src={hermesIcon} alt="" className="sidebar-logo-icon" />
          <span>Project Hermes</span>
        </div>
        <ul className="sidebar-nav">
          {NAV_ITEMS.map((item) => (
            <li key={item.id}>
              <a
                href={`#${item.id}`}
                className={currentPage === item.id ? "active" : ""}
                onClick={(e) => {
                  e.preventDefault();
                  onNavigate(item.id);
                }}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
        {email && onLogout && (
          <div className="sidebar-footer">
            <div className="sidebar-email">{email}</div>
            <button className="btn btn-sm btn-secondary" onClick={onLogout}>
              Logout
            </button>
          </div>
        )}
      </nav>
      <main className="main-content">{children}</main>
    </div>
  );
}
